<template>
  <div class="liu" v-wechat-title="'提示信息'">
    <!-- 提示信息 -->
    <div class="tips">
      <span class="txt">{{ tipsText }}</span>
    </div>
    <!-- 提交按钮 -->
    <div class="page-padding-l-r">
      <mt-button type="primary" size="large" @click="onReturnBtnClick">返回</mt-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      tipsText: '当前功能正在升级中…',
    };
  },
  methods: {
    onReturnBtnClick() {
      wx.miniProgram.navigateBack();
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  width: 90%;
  height: 20rem;
  line-height: 20rem;
  margin: 0 auto;
  text-align: center;

  .txt {
    font-size: 1.2rem;
    @include dynamic-color;
  }
}
</style>
